import {Component, computed, effect, inject, input, model, OnDestroy, OnInit, signal, ViewChild} from '@angular/core';
import {RightSearchResource} from "../../../../service/RightSearchResource";
import {FormsModule, NgForm} from "@angular/forms";
import {NgIf} from "@angular/common";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {ActivatedRoute, Router} from "@angular/router";
import {RightDetailComponent} from "../right-detail/right-detail.component";
import {FeatherModule} from "angular-feather";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {updateFormAndValidity} from "../../../../app.constants";
import {CustomErrorComponent} from "../../../../shared/commons/custom-error.component";
import {
  RegisterMethod,
  RegistrantType,
  RightSearchResult,
  Source,
  UserData
} from "../../../../../generated-model/model";
import {MenuStageService} from "../../../../shared/commons/services/menu-stage.service";
import {RegisterPanelComponent} from "../register-panel/register-panel.component";
import {StringUtils} from "../../../../shared/commons/gt-ng-datepicker/utils/string-utils";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {BtnLk2Component} from "../../../../shared/components/btn-lk2/btn-lk2.component";
import {RegistrationUtils} from "../../../../shared/commons/utils/registration-utils";
import {RegisterProxyComponent} from "../../register/proxy/register-proxy.component";
import {HasAnyAuthorityDirective} from "../../../../security/has-any-authority.directive";
import {UserDataService} from "../../../../security/user-data.service";
import {DigitOnlyModule} from "@uiowa/digit-only";

@Component({
  selector: 'app-right-search-by-pid',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    SharedCommonModule,
    RightDetailComponent,
    FeatherModule,
    NotFoundComponent,
    CustomErrorComponent,
    RegisterPanelComponent,
    BtnLk2Component,
    RegisterProxyComponent,
    HasAnyAuthorityDirective,
    DigitOnlyModule
  ],
  templateUrl: './right-search-by-personal-id.component.html',
  styleUrl: './right-search-by-personal-id.component.scss'
})
export class RightSearchByPersonalIdComponent implements OnInit, OnDestroy {
  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  showRegisterPanel = input(true, {transform: (value: boolean) => value != undefined ? value : true});
  rightSearchResource = inject(RightSearchResource);
  menuStageService = inject(MenuStageService);
  private readonly userDataService = inject(UserDataService);
  data = signal(undefined as RightSearchResult);
  source = model<Source>('NHSO');
  personalId = model<string>(undefined);
  checkDate = model<string>(undefined);
  checkTime = model<string>(undefined);
  fromMenu = computed(() => this.menuStageService.getStoredMenu());
  maxDate = signal<NgbDateStruct>(undefined);
  performSearch = signal<boolean>(false);
  registrantType: RegistrantType = undefined;
  registerMethod: RegisterMethod = 'PERSONAL_ID';
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  canBeRegistered = signal<boolean>(false);
  isChangeData = signal<boolean>(false);
  activeId = signal<number>(1);
  user = signal<UserData>(undefined);

  constructor() {
    effect(() => {
      this.canBeRegistered.set(
        this.activeId() == 1
        && !this.data()?.personalFundBackDateList?.length
        && RegistrationUtils.showRegisterPanel(this.data()?.personalData, this.data()?.personalFundList?.[0])
      );
    }, {allowSignalWrites: true});
  }

  ngOnInit(): void {
    this.userDataService.getCurrent()
      .subscribe(e => {
        this.user.set(e);
      });
    this.initialValue();
    // console.log(this.router.url)
    //todo for test
    // this.personalId.set("1600100501055");
    // this.search();
  }

  rightSearch() {
    this.registrantType = undefined;
    this.isChangeData.set(false);
    let formValid = updateFormAndValidity(this.form);
    if (formValid) {
      let effectiveDate;
      if (this.checkTime()) {
        effectiveDate = `${this.checkDate()}T${this.checkTime()}`;
      } else {
        effectiveDate = `${this.checkDate()}T00:00:00`;
      }
      this.rightSearchResource.search(this.personalId(), effectiveDate, this.source())
        .subscribe({
          next: value => {
            this.isChangeData.set(true);
            this.data.set(value);
            this.performSearch.set(true);
          },
          error: err => {
            if (err?.status == 400) {
              this.data.set(undefined);
              this.performSearch.set(true);
            }
          }
        });
    }
  }

  private initialValue() {
    this.source.set('NHSO');
    let date = new Date();
    this.maxDate.set({year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()});
    this.resetSearchParams();
    this.performSearch.set(false);
    // this.checkDate.set('2018-10-01');
    // this.checkTime.set('15:00:30');
  }

  resetSearchParams() {
    this.resetCheckDateTime()
    this.personalId.set(undefined);
    this.source.set('NHSO');
  }

  resetCheckDateTime() {
    let now = new Date();
    this.checkDate.set(`${now.getFullYear()}-${StringUtils.paddingZeroLeft(now.getMonth() + 1, 2)}-${StringUtils.paddingZeroLeft(now.getDate(), 2)}`);
    // this.checkTime.set(`00:00:00`);
    this.checkTime.set(undefined);
  }

  afterRegister() {
    this.personalId.set(undefined);
    this.data.set(undefined);
    this.router.navigate(['.'], {relativeTo: this.activatedRoute})
      .then(() => {
        this.form.resetForm();
        this.initialValue();
      });
  }

  onTabChange(activeId: any) {
    this.activeId.set(activeId);
  }

  protected register(registrantType: RegistrantType): void {
    this.rightSearchResource.registerSearch(this.personalId(), undefined, undefined)
      .subscribe({
        next: value => {
          this.isChangeData.set(true);
          this.data.set(value);
          this.registrantType = registrantType;
        },
        error: err => {
          if (err?.status == 400) {
            this.data.set(undefined);
          }
        }
      });
  }

  ngOnDestroy(): void {
  }
}
